import { IModuleProps } from '../../core/utils/modules.tsx';

import routes from './routes.tsx';

export default {
    name: 'list_of_services',
    routes,
} as IModuleProps;
